<template>
  <div class="common-layout" style="margin-top: 10px">
    <el-container class="container">
      <el-header class="header_1" height="100px">
        <el-row :gutter="20">
          <el-col :span="3">
<!--            <img style="width: 78px; height: 72px;" src="./image/ykk.png">-->
          </el-col>
          <el-col :span="5">
            <h2 style="font-size: 30px;color: #1A73E8">CW制造执行系统</h2>
            <h2 style="font-size: 25px;margin-left: 55px;color: #1A73E8">组立管理</h2>
          </el-col>
          <el-col :span="13">
            <div class="col_3">产线：{{ lineStatesData.line_name }}</div>
            <div class="col_3">线长：{{ lineStatesData.line_leader_name }}</div>
            <div class="col_3" style="margin-left: 200px;margin-top: -30px"> 物件班长：{{ lineStatesData.item_monitor_name }}</div>
            <div class="col_3">物件：{{lineStatesData.wujian_id+"("+lineStatesData.wujian_short_name+")"}}</div>
          </el-col>
          <el-col :span="3">
            <div class="col_3" style="height: 40px;line-height: 23px;width: 140px;margin-top: 25px;margin-left: -60px">
              {{currentTime }}
            </div>
          </el-col>
        </el-row>
      </el-header>
    </el-container>
    <div v-if="this.showNum === 'page4'" style="height: 100%">
      <AmLineStatesPage4 :parentData = "this.parentData"></AmLineStatesPage4>
    </div>
    <div v-if="this.showNum === 'page5'">
      <AmLineStatesPage5 :parentData = "this.parentData"></AmLineStatesPage5>
    </div>

  </div>
</template>

<script>
import AmLineStatesPage4 from "@/views/applications/assemble/lineStates/AmLineStatesPage4";
import AmLineStatesPage5 from "@/views/applications/assemble/lineStates/AmLineStatesPage5";
import {useDateFormat} from "@vueuse/core";

export default {
  name: "AmLineStatesPage",
  components: {AmLineStatesPage4, AmLineStatesPage5},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      lineStatesData:[],
      showNum: '',
      currentTime:'',
      timer1: null,
      timer2: null,
      timer3: null,
    }
  },
  computed: {},
  methods: {
    getLineStatesData() {
      this.$axios.post('am/lineStates/getLineStatesData', this.parentData).then(response => {
        let res = response.data
        this.lineStatesData = res.data
        this.showNum = "page4"
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })

    },

    dateFormat(){
      this.currentTime = useDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss dddd')
    },
  },
  unmounted() {
    clearInterval(this.timer1)
    clearInterval(this.timer2)
    clearInterval(this.timer3)
  },
  mounted() {
    this.timer1 = setInterval(()=>{
       this.dateFormat();
    }, 1000)
    this.timer2 = setInterval(() => {
      this.showNum = "page5"
      this.timer3 = setTimeout(() =>{
        this.getLineStatesData()
      },10000)
    },70000)
  },
  created() {
    this.getLineStatesData()
  }
}
</script>

<style scoped>

.common-layout {
  height: 700px;
}

.header_1 {
  border: 2px #4b8de4 solid;
  border-radius: 8px;
  margin-bottom: 5px;
  padding: 1px;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 99%;
  height: 100%;
  margin-left: 7px;
}

.col_3 {
  color: #1A73E8;
  font-size: 19px;
  font-weight: bold;
}
</style>